import Grid from "@mui/material/Grid";
import Section from "../components/ui/Section";
import FeatureCard from "../components/ui/FeatureCard";
import { WHY_FEATURES, WHY_CTA } from "../content/why";
import { headers } from "../content/meta";
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import DemoDialog from "../components/ui/DemoDialog";

export default function Features() {
  const [openDemo, setOpenDemo] = useState(false);

  return (
    <Box sx={{ bgcolor: "grey.50" }}>
      <DemoDialog open={openDemo} onClose={() => setOpenDemo(false)} />

      <Section
        id="features"
        header={{
          ...headers.features,
          title: "لماذا تختار حلولنا؟",
          subtitle: undefined,
        }}
        bgcolor="transparent"
      >
        <Grid container spacing={3}>
          {WHY_FEATURES.map(({ title, desc, Icon }) => (
            <Grid key={title} size={{ xs: 12, md: 6, lg: 4 }}>
              <FeatureCard Icon={Icon} title={title} desc={desc} />
            </Grid>
          ))}
        </Grid>

        {/* شريط CTA أسفل القسم */}
        <Container disableGutters sx={{ mt: { xs: 4, md: 6 } }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2.5, md: 3 },
              px: { xs: 3, md: 4 },
              borderRadius: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
              bgcolor: "primary.dark",
              color: "primary.contrastText",
            }}
          >
            <Stack spacing={0.5}>
              <Typography
                sx={{ fontWeight: 900, fontSize: { xs: 18, md: 20 } }}
              >
                {WHY_CTA.title}؟
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.95 }}>
                {WHY_CTA.subtitle}
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1.25} flexWrap="wrap" useFlexGap>
              <Button
                variant="contained"
                color="warning"
                onClick={() => setOpenDemo(true)}
                sx={{ fontWeight: 900, px: 6 }}
              >
                {WHY_CTA.primary}
              </Button>
            </Stack>
          </Paper>
        </Container>
      </Section>
    </Box>
  );
}
